<template>
    <div style="margin-top: 15px">
        <div class="spent-numbers-set">
            <div class="number-block">
                <div class="label">總預算</div>
                <div v-if="isBudgetHide" class="value">
                    --
                </div>
                <template v-else>
                    <div v-if="totalAmt > 0" class="value">
                        <Money :v="totalAmt" />
                        <span class="cny">{{ form.cny }}</span>
                    </div>
                    <div v-else class="value">(未設定)</div>
                    <div class="value to-twd" v-if="form.cny !== 'TWD'">
                        <span> 約當台幣 <Money :v="amtTWD" /> </span>
                        <span class="cny">TWD</span>
                        <ahTip v-if="form.cny !== 'TWD'">
                            <div style="opacity: 0.8; font-size: 10pt">匯率：{{ getCnyRat(form.cny) + " (即時)" }}</div>
                        </ahTip>
                    </div>
                </template>
            </div>
            <div>
                <div class="number-block">
                    <div class="label">
                        已支出總額
                        <ahTip>
                            <PaymentStatusLabel :statusNum="2" />
                            ＋
                            <PaymentStatusLabel :statusNum="3" />
                            的請款總額
                        </ahTip>
                    </div>
                    <div v-if="isBudgetHide" class="value">
                        --
                    </div>
                    <template v-else>
                        <div class="value">
                            <Money :v="payoutTotalCny" />
                            <span class="cny">{{ form.cny }}</span>
                        </div>
                        <div class="value to-twd" v-if="form.cny !== 'TWD'">
                            <span>約當台幣 <Money :v="payoutTotalTWD"/></span>
                            <span class="cny">TWD</span>
                            <ahTip v-if="form.cny !== 'TWD'">
                                <div style="opacity: 0.8; font-size: 10pt">匯率：{{ getCnyRat(form.cny) + " (即時)" }}</div>
                            </ahTip>
                        </div>
                    </template>
                </div>
                <div class="number-block" v-if="totalAmt > 0">
                    <div class="label">預算餘額<ahTip>總預算 - 總支出</ahTip></div>
                    <div v-if="isBudgetHide" class="value">
                        --
                    </div>
                    <template v-else>
                        <div class="value">
                            <Money :v="remainCny" />
                            <span class="cny">{{ form.cny }}</span>
                        </div>
                        <div class="value to-twd" v-if="form.cny !== 'TWD'">
                            <span>約當台幣 <Money :v="remainTWD"/></span>
                            <span class="cny">TWD</span>
                            <ahTip v-if="form.cny !== 'TWD'">
                                <div style="opacity: 0.8; font-size: 10pt">匯率：{{ getCnyRat(form.cny) + " (即時)" }}</div>
                            </ahTip>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <el-progress v-if="!isBudgetHide && totalAmt > 0" style="margin: 15px 0" :text-inside="true" :stroke-width="26" :percentage="usedPercentage"></el-progress>
    </div>
</template>

<script>
import PaymentStatusLabel from '@/components/dashboard/Payment/PaymentStatusLabel.vue';

export default {
    props: {
        form: {
            type: Object,
            default: () => {},
        },
        source: {
            type: String,
            default: null,
        },
        isBudgetHide: Boolean,
    },
    components: { PaymentStatusLabel },
    computed: {
        totalAmt() {
            if (this.source === 'payment') return this.form.payoutMax;
            return this.form.amt;
        },

        usedPercentage() {
            if (this.payoutTotalTWD > 0) {
                return Math.round((this.payoutTotalCny / this.totalAmt) * 100);
            }

            return 0;
        },

        payoutTotalTWD() {
            let sum = 0;

            this.form.payouts.forEach((item) => {
                if (item.sigN_STS === 2 || item.sigN_STS === 3) {
                    sum += Math.round(item.amt * item.paY_CNYRAT);
                }
            });

            return sum;
        },
        amtTWD() {
            return this.totalAmt * this.getCnyRat(this.form.cny);
        },
        remainTWD() {
            return this.amtTWD - this.payoutTotalTWD;
        },

        payoutTotalCny() {
            if (this.form.cny === 'TWD') return this.payoutTotalTWD;
            return Math.round((this.payoutTotalTWD / this.getCnyRat(this.form.cny)) * 100) / 100;
        },
        remainCny() {
            return this.totalAmt - this.payoutTotalCny;
        },
    },
    methods: {
        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },
    },
};
</script>

<style lang="scss" scoped>
.spent-numbers-set {
    @media (min-width: 720px) {
        display: flex;
        justify-content: space-between;
    }

    > div:nth-child(2) {
        display: flex;

        > .number-block:first-child {
            margin-right: 50px;
        }
    }

    .number-block {
        margin-bottom: 15px;

        @media (min-width: 720px) {
            margin-bottom: 0px;
        }

        .label {
            color: #555;
            font-size: 11pt;
        }
        .value {
            .money {
                font-size: 16pt;
                margin-right: 6px;
            }
            .cny {
                font-size: 10pt;
            }

            &.to-twd {
                margin-top: 5px;
                font-size: 10pt;
                opacity: 0.5;

                .money {
                    font-size: 10pt;
                }
            }
        }
    }
}
</style>
